import { AbstractCreateEntityComponent } from '@abstracts/entities/create-entity';
import { Component, Injector, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { PricingDto } from '@dto/pricingDto';
import { UserDto } from '@dto/userDto';
import { Pricing } from '@models/pricing';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PricingsService } from '@services/entity/pricings.service';
import { StripeInfosService } from '@services/entity/stripe-infos.service';
import { UsersService } from '@services/entity/users.service';
import { ToastService } from '@services/toast/toast.service';
import { plainToClass } from 'class-transformer';

@Component({
    selector: 'app-create-public-pricing',
    templateUrl: './create-public-pricing.component.html',
    styleUrls: ['./create-public-pricing.component.scss']
})
export class CreatePublicPricingComponent extends AbstractCreateEntityComponent implements OnInit {

    public className = 'CreatePublicPricingComponent'

    public ownerUserId: string
    public pricings: PricingDto[]
    public publicPricing: PricingDto
    public url: string = window.location.origin

    constructor(
        private pricingsService: PricingsService,
        public toastService: ToastService,
        private usersService: UsersService,
        private stripeInfosService: StripeInfosService,
        public activeModal: NgbActiveModal,
        injector: Injector
    ) {
        super(pricingsService, injector)
    }

    async ngOnInit() {
      super.ngOnInit()
      this.loadPricings()
    }

    async loadPricings() {
      const userId = localStorage.getItem('userId')
      this.pricingsService.getPricingsOfUser(userId).subscribe(result => {
        this.pricings = plainToClass(PricingDto, result)

        for (const pricing of this.pricings) {
            if (pricing.isPublic) {
                this.publicPricing = pricing
                break;
            }
        }

        if (this.pricings) {
            this.createForm()
        }
      }, error => {});
    }

    createForm() {
        this.formService.validators = {
            name: [Validators.required],
            description: [],
            price: [Validators.required],
            availableUsers: [],
            pricing: [],
        }

        this.formService.form = new UntypedFormGroup({
            name: new UntypedFormControl('', this.formService.validators['name']),
            description: new UntypedFormControl('', this.formService.validators['description']),
            price: new UntypedFormControl('', this.formService.validators['price']),
            availableUsers: new UntypedFormControl('', this.formService.validators['users']),
            pricing: new UntypedFormControl(this.publicPricing, this.formService.validators['users']),
        })

        window.setTimeout(() => {
            const toBeFocused = document.getElementById('name')
            if (toBeFocused) toBeFocused.focus()
        }, 500)
    }

    onSubmit(formValue) {
        var pricing = new PricingDto(formValue)
        pricing.ownerUserId = localStorage.getItem('userId')
        pricing.isPublic = true

        this.stripeInfosService.getStripeInfoOfUser(pricing.ownerUserId).subscribe(result => {
            pricing.productId = result.stripeProductId

            this.pricingsService.createPricing(pricing).subscribe(newPricing => {
                this.newDtoEvent.emit(newPricing)

                // for (const userId of formValue.availableUsers) {
                //     let userDto = new UserDto()
                //     userDto.id = userId
                //     userDto.pricingId = newPricing.id
        
                //     // this.usersService.patchPricingOfUsers(pricing).subscribe(result => {})
                // } 

                //NOTE: Public pricings have no users

                this.toastService.success(`Tarif erfolgreich erstellt.`);
                this.activeModal.close()
            }, error => {
                this.toastService.error(`Tarif konnte nicht erstellt werden.`);
                if (error.length > 0) {
                    this.messageService.setError(error)
                }
            })

        }, error => {
            this.toastService.error(`Tarif konnte nicht erstellt werden.`);
            if (error.length > 0) {
                this.messageService.setError(error)
            }
        })
    }
}
